import {mapGetters} from 'vuex'
import * as util from '@/lib/util'
import * as types from '@/store/mutation-types/'
import Sortable from 'sortablejs'
import * as apiWorks from '@/api/works'
import * as apiTalent from '@/api/talent'
import * as apiPress from '@/api/press'
import * as apiNewsletter from '@/api/newsletter'
import * as apiStories from '@/api/stories'
import * as apiMergedNews from '@/api/merged_news'
export default {
  data () {
    return {
      list: [],
      sortable: null,
      originList: [],
      sortedList: [],
      search: null,
      modalvisible: false
    }
  },
  methods: {
    getAPI () {
      let api = null
      const name = this.$route.name
      if (/talent/.test(name)) {
        api = apiTalent
      } else if (/^works/.test(name)) {
        api = apiWorks
      } else if (/^press/.test(name)) {
        api = apiPress
      } else if (/newsletter/.test(name)) {
        api = apiNewsletter
      } else if (/stories/.test(name)) {
        api = apiStories
      } else if (/mergedNews/.test(name)) {
        api = apiMergedNews
      }
      return api
    },
    getList () {
      const api = this.getAPI()
      this.$store.commit(types.LOADER, true)
      api.get().then((res) => {
        this.$store.commit(types.LOADER, false)
        this.list = res.data.data
        this.originList = this.list.map(v => v.id)
        this.sortedList = this.originList.slice()
        this.$nextTick(() => {
          // this.setSort()
        })
      })
    },
    setSort () {
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost', // Class name for the drop placeholder,
        setData: function (dataTransfer) {
          dataTransfer.setData('Text', '')
          // to avoid Firefox bug
          // Detail see : https://github.com/RubaXa/Sortable/issues/1012
        },
        onEnd: evt => {
          const targetRow = this.list.splice(evt.oldIndex, 1)[0]
          this.list.splice(evt.newIndex, 0, targetRow)
          // for show the changes, you can delete in you code
          const tempIndex = this.sortedList.splice(evt.oldIndex, 1)[0]
          this.sortedList.splice(evt.newIndex, 0, tempIndex)
        }
      })
    },
    status (data) {
      return (data === 1) ? '公開' : '非公開'
    },
    handleEdit (row, name) {
      const id = row.id
      this.$router.push({name, params: {id}})
    },
    showModal () {
      this.modalvisible = true
    },
    hideModal () {
      this.modalvisible = false
    },
    saveSort (list) {
      const api = this.getAPI()
      this.$store.commit(types.LOADER, true)
      api.postSort(list).then((res) => {
        this.$store.commit(types.LOADER, false)
        this.getList()
        this.hideModal()
      })
    }
  },
  computed: {
    sortFlg () {
      return this.originList.toString() === this.sortedList.toString()
    },
    searchedData () {
      let list = []
      if (this.search) {
        const reg = new RegExp(this.search, 'i')
        list = this.list.filter((v, i) => {
          let flg = false
          util.forEachValue(v, (ov, key) => {
            if (ov === null || typeof ov !== 'object') {
              if (key !== 'id') {
                if (reg.test(ov)) flg = true
              }
            } else if (key !== 'thumbnail' || key !== 'id') {
              util.forEachValue(ov, (oov, key) => {
                if (reg.test(oov)) flg = true
              })
            }
          })
          return flg
        })
      } else {
        list = this.list
      }
      return list
    },
    ...mapGetters([
      'LOADING'
    ])
  }
}



// WEBPACK FOOTER //
// ./src/mixins/list/index.js